import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { ButtonGroup, Card, CardContent } from "@mui/material";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import "ag-grid-enterprise";
import { ColDef, IServerSideGetRowsParams } from "ag-grid-enterprise";
import dayjs from "dayjs";
import { useContext, useEffect, useState } from "react";
import { transformationActions } from "../../service/transformation.action";
import { PromoIncrease } from "../../service/transportationInterface";
import "./../genericModels.css";
import { useTranslation } from "react-i18next";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import CustomLoader from "../../../../util/component/CustomLoader";
import EmptyState from "../../../../util/component/EmptyState";
import { setSnackbar } from "../../../../util/state/globalAction";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import { ConfirmationModalTransportator } from "./ConfirmationModalTransportator";
import PromoIncreaseModal from "./PromoIncreaseModal";
import { useHasScope } from "../../../../config/globalConfig";
import AgGridOperationTable from "../common/AgGridOperationTable";

export const TransportPromoTable = (props: any) => {
  const hasScope = useHasScope;
  const { t } = useTranslation(["operation"]);
  const { dispatchGlobalData } = useContext(GlobalContext);
  const [openModal, setOpenModal] = useState<boolean>(false);
  //const [openModalPromo, setOpernModalPromo] = useState<boolean>(props.openDialog);
  let openModalPromo = props.openDialog;
  let setOpernModalPromo = props.setOpenDialog;
  const [loading, setIsLoading] = useState(false);
  const [getIncreaseId, setGetIncreaseId] = useState<any>({});
  const [gridApi, setGridApi] = useState<any>(null);
  const [pageSize, setPageSize] = useState<number>(10);
  const [rowLength, setRowLength] = useState<number>(1);
  const [popupMessage, setPopupMessage] = useState<string>();
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const columnDefs: ColDef[] = [
    {
      field: "startDatetime",
      headerName: t(
        "transportSupplierPriceList.priceListRouteTable.startValidity"
      ),
      flex: 1,

      cellRenderer(params: any) {
        return (
          <Box component="span">
            {dayjs(`${params.data.startDatetime}`).format("DD/MM/YYYY")}
          </Box>
        );
      },
    },
    {
      field: "endDatetime",
      headerName: t(
        "transportSupplierPriceList.priceListRouteTable.endValidity"
      ),
      flex: 1,

      cellRenderer(params: any) {
        return (
          <Box component="span">
            {dayjs(`${params.data.endDatetime}`).format("DD/MM/YYYY")}
          </Box>
        );
      },
    },

    {
      field: "percentage",
      headerName: t(
        "transportSupplierPriceList.promoIncreasesTable.percentage"
      ),
      flex: 1,

      cellRenderer(params: any) {
        return (
          <Box component="span">
            {Math.sign(params.data.percentage) === -1 ? (
              <Chip
                color="success"
                sx={{ color: "white", fontWeight: "700" }}
                label={`${params.data.percentage}%`}
              />
            ) : (
              <Chip
                sx={{
                  fontWeight: "700",
                  backgroundColor: "error.main",
                  color: "white",
                }}
                label={`${params.data.percentage}%`}
              />
            )}
          </Box>
        );
      },
    },

    {
      field: "action",
      headerName: "",
      flex: 0.6,
      maxWidth: 120,
      cellStyle: { "background-color": "neutral.bright" },
      cellRenderer(params: any) {
        return (
          <Stack
            width="inherit"
            height="inherit"
            alignItems="center"
            alignContent="center"
            direction="row"
            sx={{ flexGrow: 1 }}
          >
            {(hasScope("SCOPE_CREATE_MDTRANSPORTATION_SUPPLIER") ||
              hasScope("SCOPE_UPDATE_MDTRANSPORTATION_SUPPLIER")) && (
              <ButtonGroup>
                <ButtonWithTooltip
                  tooltipText={t("tooltipTitle.editShowAction")}
                >
                  <IconButton
                    disabled={isFutureDate(params)}
                    onClick={() => openModalCreatEdit(params)}
                  >
                    <EditIcon
                      style={{
                        color: isFutureDate(params) ? "grey" : "#C8017D",
                      }}
                    />
                  </IconButton>
                </ButtonWithTooltip>
                <Box>
                  <ButtonWithTooltip tooltipText={t("tooltipTitle.delete")}>
                    <IconButton
                      disabled={isDeleteFunction(params)}
                      onClick={() => openModalFunction(params)}
                    >
                      <DeleteIcon
                        style={{
                          color: isDeleteFunction(params) ? "grey" : "#C8017D",
                        }}
                      />
                    </IconButton>
                  </ButtonWithTooltip>
                </Box>
              </ButtonGroup>
            )}
          </Stack>
        );
      },
    },
  ];
  const [openModalPerFilters, setOpenModalPerFilters] =
    useState<boolean>(false);
  const messageNote = t(
    "transportSupplierPriceList.promoIncreasesTable.messageNote"
  );

  const [message, setMessage] = useState<string>();
  let messages1 = t(
    "transportSupplierPriceList.promoIncreasesTable.deleteMessage"
  );

  const [dataFormSearch, setDataFormSearch] = useState<any>({
    startDatetime: "",
    endDatetime: "",
    percentage: "",
    id: "",
    supplierId: "",
  });
  let today = dayjs.utc().format("YYYY-MM-DD");
  let supplierId = props.getIdSupplier;

  const ButtonWithTooltip = ({
    tooltipText,
    disabled,
    onClick,
    ...other
  }: any) => {
    const adjustedButtonProps = {
      disabled: disabled,
      component: disabled ? "div" : undefined,
      onClick: disabled ? undefined : onClick,
    };
    return (
      <Tooltip title={tooltipText}>
        <IconButton {...other} {...adjustedButtonProps} />
      </Tooltip>
    );
  };
  const isDeleteFunction = (params: any) => {
    let startDate = params.data.startDatetime;
    let endDate = params.data.endDatetime;
    return startDate > today && endDate > today ? false : true;
  };

  const openModalCreatEdit = (params: any) => {
    setDataFormSearch({
      startDatetime: params.data.startDatetime,
      endDatetime: params.data.endDatetime,
      percentage: params.data.percentage,
      id: params.data.id,
      supplierId: supplierId,
    });
    setOpenModalPerFilters(true);
  };

  const openModalFunction = (params: any) => {
    setOpenModal(true);
    setGetIncreaseId(params.data.id);
    setMessage(messages1);
  };

  const isFutureDate = (params: any) => {
    let endDate = params.data.endDatetime;
    return endDate >= today ? false : true;
  };

  const SearchImportTransportation = (dataSearchForm: any) => {
    let dateTime =
      dataSearchForm?.dateTime && dayjs(dataSearchForm?.dateTime).isValid()
        ? dayjs(dataSearchForm?.dateTime).format("YYYY-MM-DD")
        : null;
    return {
      getRows: async (params: IServerSideGetRowsParams) => {
        setIsLoading(true);

        const startRow = params.request.startRow ? params.request.startRow : 0;
        const endRow = params.request.endRow;
        let pageSize = 10;
        if (
          endRow !== null &&
          endRow !== undefined &&
          startRow !== null &&
          startRow !== undefined
        ) {
          pageSize = endRow - startRow;
        }
        const pageNumber = startRow / pageSize;

        transformationActions()
          .getPromoQueryParams(
            props.getTenant,
            pageNumber,
            pageSize,
            supplierId,
            dateTime
          )
          .then((response: any) => {
            params.successCallback(
              manageData(response),
              response.data.totalElements
            );
            setRowLength(response.data.totalElements);
            

            setIsLoading(false);
          })
          .catch((error) => {
            if (error.response) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: error.response.data.error,
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setIsLoading(false);
            } else if (error.request) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: t("networkErrorMessage"),
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setIsLoading(false);
            } else {
              setIsLoading(false);
            }
            setIsLoading(false);
          });
      },
    };
  };
  function manageData(response: any) {
    let rows: any[] = [];
    response.data.content.forEach((element: any) => {
      let row = {
        id: element.id,
        startDatetime: element.startDate,
        endDatetime: element.endDate,
        percentage: element.percentage,
      };
      rows.push(row);
    });
    return rows;
  }
  const onGridReady = (params: any) => {
    setGridApi(params.api);
  };

  const editPriceIncreases = (id: number, newPromo: PromoIncrease) => {
    transformationActions()
      .editPromoIncrease(props.getTenant, id, newPromo)
      .then((response: any) => {
        dispatchGlobalData({
          type: setSnackbar,
          payload: {
            snackbar: {
              message: t(
                "transportSupplierPriceList.promoIncreasesTable.editSuccessMessage"
              ),
              type: snackbarTypes.success,
              show: true,
              autoClose: true,
            },
          },
        });
        props.setRefreshPage(!props.refreshPage);
      })
      .catch((error: any) => {
        dispatchGlobalData({
          type: setSnackbar,
          payload: {
            snackbar: {
              message: error.response.data.msg,
              type: snackbarTypes.error,
              show: true,
              autoClose: true,
            },
          },
        });
      });
  };
  const addPriceIncrease = (newPromo: PromoIncrease) => {
    transformationActions()
      .addPromoIncrease(props.getTenant, newPromo)
      .then((response: any) => {
        setShowPopup(true);
        dispatchGlobalData({
          type: setSnackbar,
          payload: {
            snackbar: {
              message: t(
                "transportSupplierPriceList.promoIncreasesTable.createSuccessMessage"
              ),
              type: snackbarTypes.success,
              show: true,
              autoClose: true,
            },
          },
        });
        props.setRefreshPage(!props.refreshPage);
      })
      .catch((error: any) => {
        dispatchGlobalData({
          type: setSnackbar,
          payload: {
            snackbar: {
              message: error.response.data.msg,
              type: snackbarTypes.error,
              show: true,
              autoClose: true,
            },
          },
        });
      });
  };
  const createOrEditPromo = (promoIncreaseObject: any) => {
    if (promoIncreaseObject.id) {
      editPriceIncreases(promoIncreaseObject.id, promoIncreaseObject);
    } else {
      addPriceIncrease(promoIncreaseObject);
    }
  };

  const deletePriceIncrease = () => {
    transformationActions()
      .deletePriceIncrease(props.getTenant, getIncreaseId)
      .then((response: any) => {
        setShowPopup(true);
        dispatchGlobalData({
          type: setSnackbar,
          payload: {
            snackbar: {
              message: t(
                "transportSupplierPriceList.promoIncreasesTable.deleteSuccessMessage"
              ),
              type: snackbarTypes.success,
              show: true,
              autoClose: true,
            },
          },
        });
        props.setRefreshPage(!props.refreshPage);
      })
      .catch((error: any) => {
        dispatchGlobalData({
          type: setSnackbar,
          payload: {
            snackbar: {
              message: error.response.data.msg,
              type: snackbarTypes.error,
              show: true,
              autoClose: true,
            },
          },
        });
      });
  };
  //props.setOpenDialog(openModalPromo)

  useEffect(() => {
    if (gridApi) {
      gridApi.setServerSideDatasource(
        SearchImportTransportation(
          !!props.dataSearchForm ? props.dataSearchForm : null
        )
      );
    }
  }, [gridApi, props.refreshPage, props.getIdSupplier]);

  return (
    <>
      <Box pl={2} pr={2}>
        <Box>
          {!props.hasSupplierId ? (
            <Box>
              <Card>
                <CardContent>
                  <Stack justifyContent="center" height={500}>
                    <EmptyState
                      title={t("transportSupplierPriceList.noSupplierMessage")}
                      content={t(
                        "transportSupplierPriceList.noSupplierContent"
                      )}
                    />
                  </Stack>
                </CardContent>
              </Card>
            </Box>
          ) : (
            <Box>
              <AgGridOperationTable
                columnDefs={columnDefs}
                onGridReady={onGridReady}
                cacheBlockSize={pageSize}
                serverSideInfiniteScroll={true}
                rowModelType={"serverSide"}
                totalElements={rowLength}

                />
            </Box>
          )}

          {loading && <CustomLoader loading={loading} />}
          {openModal && (
            <ConfirmationModalTransportator
            setOpen={openModal}
            onClose={() => setOpenModal(false)}
              title={t(
                "transportSupplierPriceList.promoIncreasesTable.deleteConfirmation"
              )}
              message={message}
              messageNote={messageNote}
              cancel={t("actionButtons.cancel")}
              confirm={t("actionButtons.delete")}
              updateAction={deletePriceIncrease}
            />
          )}

          {openModalPerFilters && (
            <PromoIncreaseModal
              addPriceIncrease={createOrEditPromo}
              setDataFormSearch={setDataFormSearch}
              setOpenModalPerFilters={setOpenModalPerFilters}
              dataFormSearch={dataFormSearch}
              supplierId={supplierId}
            />
          )}

          {openModalPromo && (
            <PromoIncreaseModal
              addPriceIncrease={addPriceIncrease}
              supplierId={props.getIdSupplier}
              setOpenModalPerFilters={setOpernModalPromo}
              setDataFormSearch={setDataFormSearch}
              dataFormSearch={dataFormSearch}
            />
          )}
        </Box>
      </Box>
    </>
  );
};
